import { Inject, Injectable, NgZone, SecurityContext } from "@angular/core";
import { DOCUMENT, DomSanitizer } from "@angular/platform-browser";
import { Router, NavigationExtras } from "@angular/router";

import { NgWindowRefService } from "../ng-services/ng-window-ref.service";
import { setTimeoutInZone, timerInZone } from "./tools";
import { Observable } from "rxjs";

@Injectable()
export class NgToolsService {

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private windowRef: NgWindowRefService,
        private router: Router,
        private ngZone: NgZone,
        private sanitize: DomSanitizer
    ) {
    }

    public goToPath(path: string, extras?: NavigationExtras): boolean {
        this.router.navigateByUrl(path, extras);
        return false;
    }

    public goToUrl(url: string): boolean {
        this.document.location.href = this.sanitize.sanitize(SecurityContext.URL, url);      // Open page in current window
        return false;
    }

    public openNewWindow(url: string) {
        window.open(this.sanitize.sanitize(SecurityContext.URL, url), "_blank");     // Open page in new window
    }

    public download(
        fileName: string,
        fileContent: string | Blob,
        mimeType: string = ""
    ): void {
        // a.href = this
        //     .windowRef
        //     .nativeWindow
        //     .URL
        //     .createObjectURL(new Blob([fileContent], {
        //         type: mimeType
        //     }));

        // https://stackoverflow.com/questions/53034797/window-url-createobjecturl-angular-7-typescript
        // export class DownloadComponent {
        //     @Input() content: any;
        //     @Input() filename = 'download.json';
        //
        //     download() {
        //         const json = JSON.stringify(this.content);
        //         const blob = new Blob([json], {type: 'application/json'});
        //         const link = document.createElement('a');
        //         link.href = URL.createObjectURL(blob);
        //         link.download = this.filename;
        //         link.click();
        //     }
        // }
        // mimeType default value is the empty string https://developer.mozilla.org/en-US/docs/Web/API/Blob/Blob
        const a = this.document.createElement("a");
        if (mimeType) {
            a.href = URL.createObjectURL(new Blob([fileContent], {
                type: mimeType
            }));
        } else {
            a.href = URL.createObjectURL(fileContent);
        }
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    public setTimeout(callback: Function, delay: number = 0): void {
        setTimeoutInZone(this.ngZone, callback, delay);
    }

    public timer(callback: Function, delay: number = 0, interval = 100): Observable<number> {
        return timerInZone(this.ngZone, callback, delay, interval);
    }
}
